import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import api from '@/lib/api';
import ReportingTree from '@/components/ReportingTree';

export default function OrgChartPage() {
  const navigate = useNavigate();
  const { user } = useAuth();
  const [divisionId, setDivisionId] = useState('me');
  const [divisions, setDivisions] = useState([]);

  useEffect(() => {
    api.get('/divisions').then(r => setDivisions(r.data)).catch(() => setDivisions([]));
  }, []);

  const canEdit = user?.role === 'ceo' || user?.role === 'leader';

  return (
    <div className="max-w-6xl mx-auto space-y-5 pb-20" data-testid="org-chart-page">
      <div>
        <h1 className="text-2xl font-bold" style={{ fontFamily: 'Georgia, serif', color: '#1B2A4A' }}>Reporting Tree</h1>
        <p className="text-sm" style={{ color: '#6B7280' }}>
          Visual org chart — drag any person onto a new manager to reassign. Changes update reporting lines (and optionally the outlet) in one click.
        </p>
      </div>

      {/* Division filter */}
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-xs font-medium" style={{ color: '#6B7280' }}>Division:</span>
        <div className="flex rounded-md border overflow-hidden" style={{ borderColor: '#E5E1DC' }}>
          {divisions.map(d => (
            <button
              key={d._id || d.id}
              onClick={() => setDivisionId(d._id || d.id)}
              className="px-3 py-1.5 text-xs"
              style={{
                backgroundColor: divisionId === (d._id || d.id) ? '#1B2A4A' : '#fff',
                color: divisionId === (d._id || d.id) ? '#fff' : '#6B7280',
              }}
              data-testid={`org-div-${d._id || d.id}`}
            >
              {d.name || d._id}
            </button>
          ))}
        </div>
      </div>

      <ReportingTree
        divisionId={divisionId}
        canEdit={canEdit}
        onPersonClick={(n) => navigate(`/people/${n.id}`)}
      />
    </div>
  );
}
